<template lang="pug">
  #resident-list(v-cloak)
    .box.d-print-none
      .box-header
        .d-flex.flex-row
          .d-flex.flex-column.flex-fill
            .title
              span 施設関係者
            .note
              span 施設関係者（職員など）のグループを作成できます。
              br
              span ID通知書を印刷して、LINEからユーザー登録できます。
          .buttons.d-flex.flex-row-reverse.justify-content-end.flex-wrap
            button.btn.add-mail-user-btn(@click="gotoOtherUserGroupMemberRegister()") メール利用の施設関係者を追加
            button.btn.add-btn(@click="gotoOtherUserGroupRegister()") グループ追加
            button.btn.group-type-list-btn(@click="gotoOtherUserGroupTypeList()") 種類一覧
      .box-body(style="padding-top:0;")
        .d-flex.justify-content-end
          .refresh-icon(@click.stop="refresh" title="再読み込みします")
        .mb-2
        OtherUserGroupTable(
          v-model="items"
          :fields="fields"
          :totalRows.sync="rows"
          :currentPage.sync="currentPage"
          :perPage="perPage"
          :isLoading="isLoading"
          :filter="filter"
          @onShowMembers="showOtherUserGroupMember"
          @onGuide="showServiceRegisterGuide"
          @onEdit="gotoOtherUserGroupEdit"
          @onDelete="showConfirmDeleteModal"
        )
        .table-options.d-flex.flex-row.justify-content-end.align-items-center.flex-wrap
          //- CSVダウンロード
          button.btn.download-btn.mr-2(:class="{ 'disable': isLoading }" :disabled="isLoading" @click="onCsvDownload") ダウンロード
          //- 検索
          .search-filter.d-flex.mr-1.align-items-center.mr-2
            b-input-group.search-filter-input-group.mr-1(size="md")
              b-input-group-prepend
                b-input-group-text.search-filter-icon
                  .search-icon
              b-form-input.search-filter-input(v-model="filter.searchWord" type="search" placeholder="検索ワードを入力してください")
            HelpIcon.d-flex.justify-content-end.align-items-center(popoverId="search-filter-help" title="検索項目について")
              template(v-slot:text)
                div 検索項目は以下になります。
                div ・種類名
                div ・施設関係者グループ名
          //- ページあたりの行数
          span.table-option-text 1ページの行数:
          .per-page
            b-form-select(
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
              size="md"
              @change="selectPerPage"
            )
          //- ページネーション
          b-pagination.m-0(
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            :disabled="isLoading"
            @change="selectPage"
            hide-goto-end-buttons
          )
    OtherUserGroupMemberDetailModal(v-model="showOtherUserGroupMemberDetailModal" :members="otherUserGroupMembers"
      @onEdit="gotoOtherUserGroupMemberEdit" @onDelete="onOtherUserGroupMemberDelete" @onSendMessage="onSendMessage"
      @onTransferMember="onTransferMember")
    TransferMemberInputModal(v-model="showTransferMemberModal" @ok="onTransferMemberOk")
    OkCancelModal(v-model="showTransferMemberConfirmModal" :title="transferMemberConfirmModalTitle" @ok="TransferMember")
    OkModal(v-model="showTransferMemberSuccessModal" :title="transferMemberSuccessModalTitle")

    OtherUserRegistrationGuidePdfModal(ref="pdf")

    CheckDeleteModal(v-model="showGroupDeleteModal" :title="deleteMessage" @ok="doDelete")
      template(#message)
        .message 削除前に以下をご確認ください。
        ul.confirm-list
          li 削除したグループに所属する施設関係者のHitomeQコネクトのユーザー登録情報も削除します。
          li 削除した施設関係者はHitomeQコネクトの機能を使用できなくなります。
          li 削除後に施設関係者が再使用する場合は、再度施設関係者にユーザー登録していただく必要があります。
    CheckDeleteModal(v-model="showLineGroupMemberDeleteModal" :title="deleteMessage" @ok="doOtherUserGroupMemberDelete")
      template(#message)
        .message 削除前に以下をご確認ください。
        ul.confirm-list
          li 削除した施設関係者はHitomeQコネクトの機能を使用できなくなります。
          li 削除後に施設関係者が再使用する場合は、再度施設関係者にユーザー登録していただく必要があります。
    CheckDeleteModal(v-model="showMailGroupMemberDeleteModal" :title="deleteMessage" @ok="doOtherUserGroupMemberDelete")
      template(#message)
        .message 削除前に以下をご確認ください。
        ul.confirm-list
          li 削除した施設関係者はHitomeQコネクトからのメールを受信できなくなります。
          li 削除後に再使用する場合は、再度ユーザー登録していただく必要があります。
    OkModal(v-model="showDeleteSuccessModal" title="削除に成功しました。")

    TestMailModal(v-model="testMailModalShow" :target.sync="testMailTargetName" :subject.sync="testMailSubject" :text.sync="testMailText"
      :targetType="2" :showValidationAlert.sync="showValidationAlert" @sendMail="confirmSendMail")
    TestMailConfirmModal(v-model="testMailConfirmModalShow" :target="testMailTargetName" :subject="testMailSubject" :text="testMailText" @sendMail="sendMail")
    OkModal(v-model="showSendMailSuccessModal" title="メールを送信しました。")

    PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Watch, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";
import { needRefreshesStore } from "@/store/store";
import { SendMessagesState } from "@/store/NeedRefreshes";
import { errorHandle } from "@/errorHandler";

import Setting from "../../../../public/setting.json";
import { PcUrl } from "@/commons/constants/PcUrl";
import OtherUserGroupsService from "@/commons/services/OtherUserGroups";
import OtherUserGroupModel, { SenderType } from "@/commons/models/OtherUserGroup";
import OtherUserGroupMembersService, { OtherUserGroupMemberTransferPostModel } from "@/commons/services/OtherUserGroupMembers";
import OtherUserGroupTypesService from "@/commons/services/OtherUserGroupTypes";
import OtherUserGroupTypeModel from "@/commons/models/OtherUserGroupType";
import SendOtherUserMailMessagesService from "@/commons/services/SendOtherUserMailMessages";
import SystemError from "@/commons/models/SystemError";
import OtherUserGroup from "@/commons/models/OtherUserGroup";

import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import HelpIcon from "@/pc/basics/HelpIcon.vue";
import CheckDeleteModal from "@/pc/components/modals/CheckDeleteModal.vue";
import OtherUserGroupMemberDetailModal from "@/pc/components/modals/OtherUserGroupMemberDetailModal.vue";
import OtherUserRegistrationGuidePdfModal from "@/pc/components/modals/OtherUserRegistrationGuidePdfModal.vue";
import OtherUserGroupTable, { OtherUserGroupTableField, OtherUserGroupTableItem, FilterSetting } from "@/pc/containers/otherUserGroups/OtherUserGroupTable.vue";
import TestMailModal from "@/pc/components/modals/TestMailModal.vue";
import TestMailConfirmModal from "@/pc/components/modals/TestMailConfirmModal.vue";
import TransferMemberInputModal from "@/pc/containers/otherUserGroups/TransferMemberInputModal.vue";
import { SendMailMessagesPostModel } from "@/commons/services/SendMailMessages";

/**
 * 施設関係者グループ一覧画面コンポーネント
 */
@Component({
  components: {
    OtherUserGroupMemberDetailModal,
    OtherUserRegistrationGuidePdfModal,
    PageLoading,
    OkCancelModal,
    OkModal,
    HelpIcon,
    CheckDeleteModal,
    TestMailModal,
    TestMailConfirmModal,
    TransferMemberInputModal,
    OtherUserGroupTable
  },
  name: "OtherUserGroupList",
  $_veeValidate: { validator: "new" }
})
export default class OtherUserGroupList extends Vue {
  /** 施設関係者グループサービス */
  @Inject("OtherUserGroupsService") otherUserGroupsService!: OtherUserGroupsService;
  /** 施設関係者グループメンバーサービス */
  @Inject("OtherUserGroupMembersService") otherUserGroupMembersService!: OtherUserGroupMembersService;
  /** 施設関係者グループ種類サービス */
  @Inject("OtherUserGroupTypesService") otherUserGroupTypesService!: OtherUserGroupTypesService;
  /** 施設関係者グループメール送信サービス */
  @Inject("SendOtherUserMailMessagesService") sendOtherUserMailMessagesService!: SendOtherUserMailMessagesService;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  /** 施設関係者グループ詳細モーダル表示状態 */
  showOtherUserGroupMemberDetailModal: boolean = false;

  /** 施設関係者グループメンバーの移動／コピーモーダル表示可否 */
  showTransferMemberModal: boolean = false;
  /** 移動／コピー対象の施設関係者グループメンバー */
  transferTargetMember: OtherUserGroup | null = null;
  /** 施設関係者グループメンバーの移動／コピーのリクエストボディ */
  transferMemberRequestBody: OtherUserGroupMemberTransferPostModel | null = null;
  /** 施設関係者グループメンバーの移動／コピーの確認モーダル表示可否 */
  showTransferMemberConfirmModal: boolean = false;
  /** 施設関係者グループメンバーの移動／コピーの確認モーダルタイトル */
  transferMemberConfirmModalTitle: string = "";
  /** 施設関係者グループメンバーの移動／コピーの完了モーダル表示可否 */
  showTransferMemberSuccessModal: boolean = false;
  /** 施設関係者グループメンバーの移動／コピーの完了モーダルタイトル */
  transferMemberSuccessModalTitle: string = "";

  /** 施設関係者グループ削除確認モーダル表示可否 */
  showGroupDeleteModal: boolean = false;
  /** LINE施設関係者グループメンバー削除確認モーダル表示可否 */
  showLineGroupMemberDeleteModal: boolean = false;
  /** MAIL施設関係者グループメンバー削除確認モーダル表示可否 */
  showMailGroupMemberDeleteModal: boolean = false;
  /** 削除完了モーダル表示可否 */
  showDeleteSuccessModal: boolean = false;

  /** テストメール送信完了モーダル表示可否 */
  showSendMailSuccessModal: boolean = false;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** 施設関係者列名 */
  fields: Array<OtherUserGroupTableField> = [];
  /** 施設関係者各行の情報 */
  items: Array<OtherUserGroupTableItem> = [];
  /** 読込み中か否か */
  isLoading: boolean = true;

  /** 削除対象の施設関係者グループID */
  deleteTargetId: number = 0;
  /** 削除モーダルに表示するメッセージ */
  deleteMessage: string = "";
  /** 施設関係者メンバー削除対象の施設関係者グループID */
  deleteTargetGroupId: number = 0;
  /** 施設関係者メンバー削除対象の施設関係者グループメンバーID */
  deleteTargetMemberId: number = 0;
  /** モーダル表示対象の施設関係者グループメンバー */
  otherUserGroupMembers: any = {};

  /** テストメールモーダルの表示状態 */
  testMailModalShow: boolean = false;
  /** テストメール宛先 */
  testMailTargetAddress: string = "";
  /** テストメール宛先施設関係者のソートキー */
  testMailTargetSortKey: string = "";
  /** テストメール宛先施設関係者名 */
  testMailTargetName: string = "";
  /** テストメール宛先施設関係者名 */
  testMailName: string = "";
  /** テストメールタイトル */
  testMailSubject: string = "";
  /** テストメール本文 */
  testMailText: string = "";

  /** テストメール確認モーダルの表示状態 */
  testMailConfirmModalShow: boolean = false;

  /** フィルタリング条件 */
  filter: FilterSetting = { searchWord: "" };
  /** ページングの現在ページ番号 */
  currentPage: number = 1;
  /** ページングの全体行数 */
  rows: number = 0;
  /** 1ページに表示する行数 */
  perPage: number = Number(Setting.otherUserGroup.perPage);
  /** 1ページに表示する行数の選択項目 */
  pageOptions: number[] = Setting.otherUserGroup.pageOptions;

  /**
   * ### 1ページあたりの表示行数の変更イベント
   *
   * - 変更をクッキーに持たせる
   */
  @Watch("perPage")
  public changePerPage(perPage: number): void {
    this.setCookie(perPage);

    return;
  }

  /**
   * ### 1ページあたりの表示行数をCookieに設定する
   */
  public setCookie(perPage: number): void {
    // Cookie有効秒数。有効期限は必ず設定しないといけないので、10年分にしておく
    const saveSecond = 10 * 365 * 24 * 60 * 60;
    document.cookie = `other-user-group-list-per-page=${perPage}; max-age=${saveSecond};`;

    return;
  }

  /**
   * vue lifecycle mounted
   *
   * 画面表示情報の作成を行う
   */
  public async mounted(): Promise<void> {
    // 画面初期表示時に作成して変更しないものを初期化する
    const fields: Array<OtherUserGroupTableField> = this.createFields();
    this.fields = fields;
    // 1ページあたりの表示行数はCookieから取得する。取得できない場合はデフォルト値を使用する
    const perPage: number | null = this.loadCookie();
    this.perPage = perPage ? perPage : Number(Setting.otherUserGroup.perPage);

    await this.initialize();

    return;
  }

  /**
   * ### 画面初期化
   */
  public async initialize(): Promise<void> {
    this.isLoading = true;

    this.items = [];
    this.currentPage = 1;

    await this.createView();

    this.isLoading = false;

    return;
  }

  /**
   * ### 施設関係者の列名を作成する
   */
  public createFields(): Array<OtherUserGroupTableField> {
    let fields: Array<OtherUserGroupTableField> = [];

    fields.push({ key: "type", label: "種類", sortable: false, sortDirection: "desc", class: "type" });
    fields.push({ key: "name", label: "グループ名", sortable: false, sortDirection: "desc", class: "group-name" });
    fields.push({ key: "id", label: "グループID", sortable: false, sortDirection: "desc", class: "group-id" });
    fields.push({ key: "member", label: "メンバー", sortable: false, sortDirection: "desc", class: "member" });
    fields.push({ key: "print", label: "ID通知書", sortable: false, sortDirection: "desc", class: "text-center print" });
    fields.push({ key: "operation", label: "登録情報", sortable: false, sortDirection: "desc", class: "text-center operation" });

    return fields;
  }

  /**
   * ### Cookieを見て、値が保持されている場合はCookieの値を返す
   */
  public loadCookie(): number | null {
    if (document.cookie) {
      let cookieMap: any = {};
      let cookies: Array<string> = document.cookie.split("; ");
      cookies.forEach(function (value) {
        //cookie名と値に分ける
        let content = value.split("=");
        cookieMap[content[0]] = content[1];
      });

      // cookieに値が格納されていないとundefinedが格納されているが、実際にはゴミデータが格納されているのでisNaN()でチェックが必要
      const perPage: number = Number(cookieMap["other-user-group-list-per-page"]);

      return isNaN(perPage) ? null : perPage;
    }

    return null;
  }

  /**
   * ### 画面情報作成
   */
  public async createView(): Promise<void> {
    // 全体の行数を非同期で取得する
    this.setRows();

    // 施設関係者テーブルに渡す各プロパティを作成する
    const otherUserGroupTypes: Array<OtherUserGroupTypeModel> = await this.getOtherGroupTypes();
    const otherUserGroupTypesMap: Map<number, string> = this.createOtherUserGroupTypesMap(otherUserGroupTypes);

    const otherUserGroups: Array<OtherUserGroupModel> = await this.getOtherUserGroups();
    const items: Array<OtherUserGroupTableItem> = this.createItems(otherUserGroups, otherUserGroupTypesMap);
    this.items = items;

    return;
  }

  /**
   * ### ページング用の全件数を設定する
   */
  public async setRows() {
    try {
      const count: number = await this.otherUserGroupsService.getCount(userStore);
      this.rows = count;
    } catch (error) {
      // 本処理はawaitされない非同期処理なので、共通エラーハンドラーが例外をキャッチしない
      // 例外発生時は自分でエラーハンドラーを呼ぶ
      errorHandle(error, this);
    }

    return;
  }

  /**
   * ### 施設関係者グループ種類を取得する
   */
  public async getOtherGroupTypes(): Promise<Array<OtherUserGroupTypeModel>> {
    const otherUserGroupTypes: Array<OtherUserGroupTypeModel> = await this.otherUserGroupTypesService.get(userStore);
    return otherUserGroupTypes;
  }

  /**
   * ### 画面表示用に施設関係者グループ種類のMAPを作成する
   */
  public createOtherUserGroupTypesMap(otherUserGroupTypes: Array<OtherUserGroupTypeModel>): Map<number, string> {
    let map: Map<number, string> = new Map<number, string>();

    for (const type of otherUserGroupTypes) {
      map.set(type.id, type.name);
    }

    return map;
  }

  /**
   * ### 施設関係者グループを取得する
   *
   * - 取得制限をしないためstartIndex、endIndexを指定しない
   */
  public async getOtherUserGroups(): Promise<Array<OtherUserGroupModel>> {
    let response: Array<OtherUserGroupModel> = [];

    try {
      response = await this.otherUserGroupsService.gets(userStore);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const count: number = await this.otherUserGroupsService.getCount(userStore);
        const loopEnd: number = Math.ceil(count / 300);

        for (let i = 0; i < loopEnd; i++) {
          const params: any = {
            startIndex: i * 300,
            endIndex: i * 300 + 300
          };
          response = response.concat(await this.otherUserGroupsService.gets(userStore, params));
        }
      }
    }
    return response;
  }

  /**
   * ### 施設関係者グループの行を作成する
   */
  public createItems(otherUserGroups: Array<OtherUserGroupModel>, otherUserGroupTypesMap: Map<number, string>): Array<OtherUserGroupTableItem> {
    let items: Array<OtherUserGroupTableItem> = [];

    for (const group of otherUserGroups) {
      const typeName: string | undefined = otherUserGroupTypesMap.get(group.groupTypeId);

      items.push({
        facilityId: group.facilityId,
        id: group.id,
        groupTypeId: group.groupTypeId,
        type: typeName ? typeName : "種類未設定",
        name: group.name,
        memberCount: group.memberCount,
        password: group.password,
        updated: group.updated
      });
    }

    return items;
  }

  /**
   * ### vue lifecycle activated
   */
  public async activated(): Promise<void> {
    this.$validator.errors.clear();
    this.showValidationAlert = false;

    if (needRefreshesStore.otherUserGroupList.otherUserGroupList == true) {
      await this.createView();
      needRefreshesStore.otherUserGroupList.otherUserGroupList = false;
    }
    return;
  }

  /**
   * ### 1ページあたりの表示行数変更イベント
   *
   * - 1ページあたりの表示行数を更新
   * - ページあたりの表示行数が変わるので表の情報を作り直す
   */
  public async selectPerPage(perPage: number): Promise<void> {
    this.perPage = perPage;
    this.currentPage = 1;
    return;
  }

  /**
   * ### ページネーションのページ番号押下
   */
  public async selectPage(page: number): Promise<void> {
    this.currentPage = page;
    return;
  }

  /**
   * ### 施設関係者グループメンバーの詳細情報を表示する
   */
  public async showOtherUserGroupMember(otherUserGroup: OtherUserGroupTableItem): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    this.otherUserGroupMembers = await this.getOtherUserGroupMember(otherUserGroup);

    this.isBusy = false;

    this.showOtherUserGroupMemberDetailModal = true;

    return;
  }

  /**
   * ### 施設関係者グループにひもづくメンバーを取得する
   */
  public async getOtherUserGroupMember(otherUserGroup: OtherUserGroupTableItem): Promise<Array<OtherUserGroupModel>> {
    const response: Array<OtherUserGroupModel> = await this.otherUserGroupMembersService.get(userStore, otherUserGroup.id);
    return response;
  }

  /**
   * ### プリントボタン押下処理
   *
   * ID・パスワードを表示するPDFをダイアログ表示する
   */
  public async showServiceRegisterGuide(otherUserGroup: OtherUserGroupTableItem): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    try {
      const liffUrl: string = await this.otherUserGroupsService.getLiffUrl(userStore, otherUserGroup.id);
      // プレビュー表示は子コンポーネントに機能を委譲しているので、子コンポーネントを表示するのみ
      const pdf: OtherUserRegistrationGuidePdfModal | Vue | Element | Vue[] | Element[] = this.$refs.pdf;
      if (pdf instanceof OtherUserRegistrationGuidePdfModal) {
        await pdf.show(otherUserGroup, liffUrl);
      }
    } finally {
      this.isBusy = false;
    }
    return;
  }

  /**
   * ### 施設関係者グループ登録画面へ遷移
   */
  public gotoOtherUserGroupRegister(): void {
    this.$router.push(PcUrl.OtherUserGroupRegister);
    return;
  }

  /**
   * ### 施設関係者グループメンバー登録画面へ遷移
   */
  public gotoOtherUserGroupMemberRegister(): void {
    this.$router.push(PcUrl.OtherUserGroupMemberRegister);
    return;
  }

  /**
   * ### 施設関係者グループ編集画面へ遷移
   */
  public gotoOtherUserGroupEdit(otherUserGroup: OtherUserGroupTableItem): void {
    this.$router.push({ name: PcUrl.OtherUserGroupEdit, params: { id: `${otherUserGroup.id}` } });
    return;
  }

  /**
   * ### 施設関係者グループ種類編集画面へ遷移
   */
  public gotoOtherUserGroupTypeList(): void {
    this.$router.push(PcUrl.OtherUserGroupTypeList);
    return;
  }

  /**
   * ### 削除確認モーダルを表示する
   *
   * - 削除メッセージは動的に作成する
   */
  public showConfirmDeleteModal(otherUserGroup: OtherUserGroupTableItem): void {
    const name: string = otherUserGroup.name ? otherUserGroup.name : "";
    this.deleteMessage = `${name}を削除しますか？`;
    this.showGroupDeleteModal = true;

    this.deleteTargetId = otherUserGroup.id;

    return;
  }

  /**
   * ### 施設関係者グループとひもづくメンバーを削除する
   */
  public async doDelete(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "削除中...";

    await this.otherUserGroupsService.delete(userStore, this.deleteTargetId);

    // 削除成功ダイアログを表示する
    this.showDeleteSuccessModal = true;
    this.isBusy = false;

    // itemsから削除するだけで再取得リクエストはしない
    this.items = this.items.concat().filter((item: OtherUserGroupTableItem) => {
      if (item.id == this.deleteTargetId) {
        return false;
      } else {
        return true;
      }
    });
    this.rows--;
    // メッセージ送信の宛先が変更になるので再読み込みさせるようstoreを更新
    let sendMessageState: SendMessagesState = needRefreshesStore.sendMessage;
    sendMessageState.sendMessages = true;
    needRefreshesStore.setSendMessage(sendMessageState);

    return;
  }

  /**
   * ### 施設関係者グループメンバー編集画面へ遷移
   */
  public gotoOtherUserGroupMemberEdit(member: OtherUserGroupModel): void {
    this.showOtherUserGroupMemberDetailModal = false;
    this.$router.push({ name: PcUrl.OtherUserGroupMemberEdit, params: { groupid: `${member.id}`, id: `${member.memberId}` } });
    return;
  }

  /**
   * ### 施設関係者グループメンバーの削除ボタン押下イベント
   *
   * - 削除メッセージは動的に作成する
   */
  public onOtherUserGroupMemberDelete(member: OtherUserGroupModel): void {
    this.showOtherUserGroupMemberDetailModal = false;

    const memberName: string = member.memberName ? member.memberName : "";
    this.deleteMessage = `${memberName}を削除しますか？`;

    if (member.senderType == SenderType.LINE) {
      this.showLineGroupMemberDeleteModal = true;
    } else if (member.senderType == SenderType.MAIL) {
      this.showMailGroupMemberDeleteModal = true;
    }

    this.deleteTargetGroupId = member.id;
    this.deleteTargetMemberId = member.memberId;

    return;
  }

  /**
   * ### 施設関係者グループメンバーを削除する
   */
  public async doOtherUserGroupMemberDelete(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "削除中...";

    await this.otherUserGroupMembersService.delete(userStore, this.deleteTargetGroupId, this.deleteTargetMemberId);

    // メンバーを削除した施設関係者グループの情報を更新するだけで再取得リクエストはしない
    for (const item of this.items) {
      if (item.id == this.deleteTargetGroupId) {
        item.memberCount--;
      }
    }
    // メッセージ送信の宛先が変更になるので再読み込みさせるようstoreを更新
    let sendMessageState: SendMessagesState = needRefreshesStore.sendMessage;
    sendMessageState.sendMessages = true;
    needRefreshesStore.setSendMessage(sendMessageState);

    // 削除成功ダイアログを表示する
    this.showDeleteSuccessModal = true;
    this.isBusy = false;

    return;
  }

  /**
   * ### テストメール送信モーダルを表示する
   *
   * - テストメール送信モーダルに必要な情報を作成する
   * - モーダルを表示する
   */
  public onSendMessage(member: OtherUserGroupModel): void {
    this.testMailTargetAddress = member.memberMailaddress ? member.memberMailaddress : "";
    this.testMailTargetSortKey = member.otherUserGroupsSortKey;
    this.testMailTargetName = `${member.memberName}様`;
    this.testMailName = `${member.memberName}`;
    this.testMailSubject = "HitomeQコネクト登録確認メール";
    this.testMailText =
      "HitomeQコネクトのメール配信サービスへのお申し込みありがとうございます。\n" +
      "お申し込みのメールアドレスを登録致しました。\n" +
      "後ほど受信確認のご連絡をさせていただきます。\n\n" +
      "もしお心当たりの無い場合は、本メールを削除してください。";

    this.testMailModalShow = true;

    return;
  }

  /**
   * ### テストメール送信確認モーダルを表示する
   *
   * - テストメールの内容をバリデーションする
   * - バリデーションで問題が無ければテストメール確認モーダルを表示する
   */
  public async confirmSendMail(): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();
    if (validationResult) {
      this.showValidationAlert = false;
      this.testMailConfirmModalShow = true;
    } else {
      this.showValidationAlert = true;
    }
    return;
  }

  /**
   * ### テストメールを送信する
   *
   * - メールを送信するのでテストメールモーダル、テストメール確認モーダルを非表示にする
   * - メール送信用のパラメータを作成する
   * - メールを送信する
   */
  public async sendMail(): Promise<void> {
    this.showOtherUserGroupMemberDetailModal = false;
    this.testMailModalShow = false;
    this.testMailConfirmModalShow = false;

    this.isBusy = true;
    this.loadingMessage = "送信中...";

    const sendMailMessage: SendMailMessagesPostModel = this.createSendMailMessageModel();
    await this.sendOtherUserMailMessagesService.post(userStore, sendMailMessage);

    // 送信成功ダイアログを表示する
    this.showSendMailSuccessModal = true;
    this.isBusy = false;

    return;
  }

  /**
   * ### メール送信用パラメータを作成する
   */
  public createSendMailMessageModel(): SendMailMessagesPostModel {
    const sendMailMessage: SendMailMessagesPostModel = {
      sortKeys: [this.testMailTargetSortKey],
      targetName: this.testMailTargetName,
      subject: this.$stringUtil.convertYen(this.testMailSubject),
      text: this.$stringUtil.convertYen(this.testMailText),
      writerId: userStore.loginUser.userId,
      writtenBy: userStore.loginUser.name,
      // メッセージ送信画面でしか使用しないので以下は空相当の情報を格納する
      type: "",
      addOptionText: false,
      addReadButton: false,
      addReplyButton: false,
      fileUrls: [],
      fileNames: [],
      addReceivedMessageUrl: false,
      needDbRegister: false
    };

    return sendMailMessage;
  }

  public onTransferMember(member: OtherUserGroup): void {
    this.transferTargetMember = member;
    this.showTransferMemberModal = true;
    return;
  }

  public onTransferMemberOk(requestBody: OtherUserGroupMemberTransferPostModel): void {
    this.transferMemberRequestBody = requestBody;

    const transferType: string = requestBody.needDelete ? "移動" : "コピー";
    this.transferMemberConfirmModalTitle = `施設関係者グループメンバーを${transferType}しますか？`;
    this.showTransferMemberConfirmModal = true;
    return;
  }

  public async TransferMember(): Promise<void> {
    const transferType: string = this.transferMemberRequestBody!.needDelete ? "移動" : "コピー";

    this.loadingMessage = `施設関係者グループメンバーを${transferType}してします...`;
    this.isBusy = true;

    await this.otherUserGroupMembersService.postTransfer(
      userStore,
      this.transferTargetMember!.id,
      this.transferTargetMember!.memberId,
      this.transferMemberRequestBody as OtherUserGroupMemberTransferPostModel
    );

    // 移動の場合、対象の施設関係者グループのメンバー数をデクリメントする
    if (this.transferMemberRequestBody?.needDelete == true) {
      for (const item of this.items) {
        if (item.id == this.transferTargetMember!.id) {
          item.memberCount--;
        }
      }
    }

    this.showOtherUserGroupMemberDetailModal = false;
    this.showTransferMemberModal = false;
    this.transferMemberSuccessModalTitle = `${this.transferTargetMember!.memberName}の${transferType}に成功しました`;
    this.showTransferMemberSuccessModal = true;

    this.isBusy = false;

    return;
  }

  /**
   * ### 施設関係者グループメンバー一覧をCSVダウンロードする
   */
  public async onCsvDownload(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    const membersInFacility: Array<OtherUserGroup> = await this.getOtherUserGroupMembersInFacility();
    const csv: string = this.createCsv(membersInFacility);
    const fileName: string = this.createCsvFileName();
    this.downloadCsv(csv, fileName);

    this.isBusy = false;
    return;
  }

  /**
   * ### 施設にひもづく全施設関係者を取得する
   */
  public async getOtherUserGroupMembersInFacility(): Promise<Array<OtherUserGroup>> {
    const response: Array<OtherUserGroup> = await this.otherUserGroupMembersService.get(userStore);
    return response;
  }

  /**
   * ### 施設関係者グループメンバ一覧CSVを作成する
   *
   * - 1行目の先頭はexcel等での文字化け対策でBOMを付与する
   * - 1行目は項目名を作る
   * - 2行目以降は行情報にあたる情報を作成して出力する
   */
  public createCsv(members: Array<OtherUserGroup>): string {
    const csv: string[] = [];
    const rowNames: string[] = ["種類", "グループ名", "ユーザー名", "電話番号", "所属", "送信手段"];
    csv.push(`\ufeff` + `${rowNames.join(",")}`);

    for (const member of members) {
      const line: string[] = [];

      line.push(member.groupTypeName);
      line.push(member.name);
      line.push(member.memberName);
      line.push(member.memberTel ? `="${member.memberTel}"` : "");
      line.push(member.memberOrganization);
      line.push(member.senderType == SenderType.LINE ? "LINE" : "メール");

      csv.push(`${line.join(",")}`);
    }
    return csv.join("\n");
  }

  /**
   * ### CSVファイル名を作成する
   */
  public createCsvFileName(): string {
    const date: string = this.$dateUtil.convertDateToString(new Date(), "yyyymmdd");
    const fileName: string = `HitomeQコネクト-施設関係者グループメンバー一覧-${date}.csv`;
    return fileName;
  }

  /**
   * ### CSVファイルをダウンロードさせる
   *
   * - CSVの内容からblobファイルを作成する
   * - blobファイルの種別はtext/csv
   * - a要素を作ってそれを疑似的にクリックさせることでダウンロードさせる
   */
  public downloadCsv(csv: string, fileName: string): void {
    const blob: Blob = new Blob([csv], { type: "text/csv" });
    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    return;
  }

  /**
   * ### 画面情報を再取得する
   */
  public async refresh(): Promise<void> {
    await this.initialize();
    return;
  }

  /**
   * ### vue lifecycle deactivated
   *
   * - コンポーネントをkeep-aliveでキャッシュしている
   * - validatorインスタンスもキャッシュしてしまっているので、リセットする
   */
  async deactivated() {
    await this.$validator.reset();
    this.$validator.errors.clear();
    this.showValidationAlert = false;
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

#resident-list {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;

  .box-header {
    .title {
      font-size: 22px;
      font-weight: bold;
    }

    .group-type-list-btn,
    .add-btn {
      width: 130px;
      margin-right: 12px;
    }
    .add-mail-user-btn {
      width: 274px;
    }
  }

  .box-body {
    .refresh-icon {
      @include svg-icon("../../../assets/refresh.svg", $font-base-color, 20px, 20px);
      opacity: 0.5;
      text-shadow: 0 1px 0 #fff;
      cursor: pointer;
    }
    .refresh-icon:hover {
      opacity: 0.75;
    }
  }
  .download-btn {
    height: 38px !important;
  }
}
</style>
